var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thumbnail"},[_c('img',{style:({
			maxHeight: _vm.imgMaxHeight,
		}),attrs:{"src":_vm.getThumbnailSrc()},on:{"click":function($event){_vm.show_origin = true}}}),_c('v-dialog',{attrs:{"width":"auto"},model:{value:(_vm.show_origin),callback:function ($$v) {_vm.show_origin=$$v},expression:"show_origin"}},[_c('img',{staticStyle:{"width":"auto","max-height":"85vh"},attrs:{"src":_vm.src},on:{"click":function($event){_vm.show_origin = false}}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }